import ResultType from '../enums/ResultType.js';
import ResultData from '../enums/ResultData.js';

const filterOnlyHits = function(){
    return [ { parameter: [ResultData.Type.key], operator: '===', value: ResultType.Hit.key }];
};

const filterOnlyPitches = function(){
    return [ { parameter: [ResultData.Type.key], operator: '===', value: ResultType.Pitch.key }];
};

const filterOnlyHitsWithoutPitches = function (){
    let hitsOnly = filterOnlyHits();
    hitsOnly.push({ parameter: [ResultData.PitchId.key], operator: '==', value: '0' });
    return hitsOnly;
};

export {
    filterOnlyHits, filterOnlyPitches, filterOnlyHitsWithoutPitches
};
